import React from "react";

import {object, string} from "yup";
import {Grid, Box} from "@material-ui/core";
import trim from "mn-utils/trim";

import {FormWrapper, FormSubmitBtn} from "../../../../../dumb/FormHandlers";
import {MerchantInputPassword} from "../../../../../dumb/FormInputs";
import {account$} from "../../../../../../emitters/account";
import {apiAuthUpdatePwd} from "../../../../../../api/_auth";

export default () => {
  const trimHandler = [trim];

  const schema = object({
    old_pass: string()
      .isValidOldPwd()
      .isValidPwdLength()
      .withoutCyrillicSymbols()
      .required(),
    new_pass: string()
      .isValidNewPwd()
      .isValidPwdLength()
      .withoutCyrillicSymbols()
      .required(),
    repeat_pass: string()
      .test(
        'passRepeatCheck',
        'Password must be the same as a new one',
        (val, ctx) => {
          return val === ctx.parent.new_pass;
        }
      )
      .required()
  });

  const onSubmit = (data) => {
    const {name, login} = account$.getValue();

    return apiAuthUpdatePwd({
      name,
      login,
      old_password: data.old_pass,
      password: data.new_pass,
    })
  }

  return (
    <FormWrapper
      schema={schema}
      onSubmit={onSubmit}
      resultModalData={['Password has been changed']}
      clearDataOnResult
    >{(formCtx) => {
      return (
        <>
          <Box mt="35px">
            <Grid container spacing={8}>
              <Grid item md={6} xs={12}>
                <MerchantInputPassword
                  label="Current Password"
                  name="old_pass"
                  formCtx={formCtx}
                  onChangeHandlers={trimHandler}
                />
                <Box mt="27px" className="fw4 f12 lh18 lts0em tl">
                  <b>Note:</b> Make sure your new password is strong enough. <br/>
                  Password must contain latin letters, numbers, symbols, be at least <b>six characters long</b> and have minimum <b>one number</b> in it.
                </Box>
              </Grid>
              <Grid item md={6} xs={12}>
                <MerchantInputPassword
                  label="New password"
                  name="new_pass"
                  formCtx={formCtx}
                  onChangeHandlers={trimHandler}
                />
                <Box mt="2.7rem">
                  <MerchantInputPassword
                    label="Repeat new password"
                    name="repeat_pass"
                    formCtx={formCtx}
                    onChangeHandlers={trimHandler}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
          <Box maxWidth="27rem" mt="3.5rem">
            <FormSubmitBtn formCtx={formCtx}>
              Change Password
            </FormSubmitBtn>
          </Box>
        </>
      )
    }}</FormWrapper>
  )
}
